import { render } from "./userhud.vue?vue&type=template&id=bcff03bc"
import script from "./userhud.vue?vue&type=script&lang=js"
export * from "./userhud.vue?vue&type=script&lang=js"

import "./userhud.vue?vue&type=style&index=0&id=bcff03bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__